'use client';
import { useState, type FormEvent } from 'react';
export function ContactEmailForm() {
  const [prepared, setPrepared] = useState(false);
  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const values = new FormData(event.currentTarget);
    const text = `Name: ${values.get('name')}\nWork email: ${values.get('email')}\nCompany: ${values.get('company')}\nPhone: ${values.get('phone')}\n\n${values.get('message')}`;
    window.location.href = `mailto:mentroxdigitalsolution@gmail.com?subject=${encodeURIComponent('Mentrox OneHR enquiry — ' + values.get('company'))}&body=${encodeURIComponent(text)}`;
    setPrepared(true);
  }
  return (
    <form onSubmit={submit} className="rounded-xl border border-slate-200 p-6">
      <h2 className="text-xl font-bold">Prepare an email enquiry</h2>
      <p className="mt-3 text-sm leading-7 text-slate-600">
        This form opens a draft in your email application. Review it and send it there. It does not
        submit or store an enquiry on this website.
      </p>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {[
          { name: 'name', label: 'Name', type: 'text' },
          { name: 'email', label: 'Work email', type: 'email' },
          { name: 'company', label: 'Company', type: 'text' },
          { name: 'phone', label: 'Phone (optional)', type: 'tel' },
        ].map((f) => (
          <label key={f.name} className="text-sm font-semibold">
            {f.label}
            <input
              required={f.name !== 'phone'}
              name={f.name}
              type={f.type}
              autoComplete={
                f.name === 'name'
                  ? 'name'
                  : f.name === 'email'
                    ? 'email'
                    : f.name === 'phone'
                      ? 'tel'
                      : 'organization'
              }
              maxLength={150}
              className="mt-2 w-full rounded-lg border border-slate-300 px-3 py-3 text-sm font-normal"
            />
          </label>
        ))}
      </div>
      <label className="mt-4 block text-sm font-semibold">
        How can we help?
        <textarea
          required
          name="message"
          rows={5}
          maxLength={2000}
          className="mt-2 w-full rounded-lg border border-slate-300 px-3 py-3 text-sm font-normal"
        />
      </label>
      <button
        type="submit"
        className="mt-5 rounded-full bg-[#c94e00] px-6 py-3 text-sm font-semibold text-white hover:bg-orange-800"
      >
        Open email draft
      </button>
      {prepared && (
        <p role="status" className="mt-4 text-sm leading-7 text-slate-600">
          An email draft was requested. Nothing has been sent by this website. If your email app did
          not open, use the email address on this page or the Request Demo form.
        </p>
      )}
    </form>
  );
}
